import React, { Component } from 'react';
import { Icon } from '@material-ui/core';


export default class CustomIcon extends Component {



  render() {

    return (
      <span className={`icon-${this.props.name}`} style={this.props.style}></span>
    )
  }


}



// WEBPACK FOOTER //
// ./src/elements/icon/CustomIcon.js